import React from 'react';
import { Modal } from 'react-bootstrap';

export default function InfoModal({
  title,
  show,
  onHide,
  children,
}: {
  title: string;
  show: boolean;
  onHide: () => void;
  children: React.ReactNode;
}) {
  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="agro-overview-info-modal">
      {/* Cabeçalho no padrão do popover "Informações da rodada" do Flux:
          faixa compacta com título à esquerda e botão × à direita. */}
      <Modal.Header>
        <span>{title}</span>
        <button
          type="button"
          className="agro-overview-info-modal-close"
          aria-label="Fechar"
          onClick={onHide}
        >
          ×
        </button>
      </Modal.Header>
      <Modal.Body className="agro-overview-info-modal-body">
        {children}
      </Modal.Body>
    </Modal>
  );
}
